(() => {
  const existing = window.__glxBundleSelectVisualV1;
  if (existing?.version === 'v1.1-touch-native') {
    existing.refresh?.();
    return;
  }

  const SCOPE = '[data-glx-bundle-drawer="v10e"]';
  const SELECTOR = `${SCOPE} select[data-p], ${SCOPE} select[data-v], ${SCOPE} select[data-v-fixed]`;
  const OPEN_SELECTOR = `${SCOPE} .glx-smart-select.is-open`;
  const TOUCH_MAX_WIDTH = 1400;
  let uid = 0;
  let raf = 0;

  const isTouchNativeMode = () => {
    const narrowEnough = window.innerWidth <= TOUCH_MAX_WIDTH;
    const coarse = window.matchMedia?.('(pointer: coarse)')?.matches || false;
    const noHover = window.matchMedia?.('(hover: none)')?.matches || false;
    const touchPoints = Number(navigator.maxTouchPoints || 0) > 0;
    return narrowEnough && (coarse || noHover || touchPoints);
  };

  let style = document.getElementById('glx-bundle-select-visual-v1-styles');
  if (!style) {
    style = document.createElement('style');
    style.id = 'glx-bundle-select-visual-v1-styles';
    document.head.appendChild(style);
  }
  style.textContent = `
${SCOPE} .glx-native-select--visual{position:absolute!important;width:1px!important;height:1px!important;min-height:1px!important;margin:0!important;padding:0!important;border:0!important;opacity:0!important;pointer-events:none!important;clip-path:inset(50%)!important;overflow:hidden!important}
${SCOPE} .glx-smart-select{position:relative;min-width:0;width:100%}
${SCOPE} .glx-smart-select__trigger{width:100%;min-height:44px;display:flex;align-items:center;justify-content:space-between;gap:10px;padding:10px 12px;border:1px solid rgba(var(--color-foreground),.18);border-radius:10px;background:linear-gradient(145deg,rgba(255,255,255,.035),rgba(126,87,255,.035)),rgb(var(--color-background));color:inherit;font:inherit;text-align:left;cursor:pointer;box-sizing:border-box;transition:border-color .16s ease,box-shadow .16s ease,background .16s ease}
${SCOPE} .glx-smart-select__trigger:hover{border-color:rgba(174,145,255,.46);background:linear-gradient(145deg,rgba(255,255,255,.045),rgba(126,87,255,.075)),rgb(var(--color-background))}
${SCOPE} .glx-smart-select.is-open .glx-smart-select__trigger,${SCOPE} .glx-smart-select__trigger:focus-visible{border-color:rgba(174,145,255,.74);outline:none;box-shadow:0 0 0 3px rgba(126,87,255,.10),0 0 22px rgba(126,87,255,.08)}
${SCOPE} .glx-smart-select__trigger:disabled{opacity:.58;cursor:not-allowed}
${SCOPE} .glx-smart-select__value{display:block;min-width:0;flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
${SCOPE} .glx-smart-select__chevron{width:8px;height:8px;flex:0 0 8px;border-right:1.5px solid currentColor;border-bottom:1.5px solid currentColor;transform:rotate(45deg) translateY(-2px);opacity:.72;transition:transform .16s ease}
${SCOPE} .glx-smart-select.is-open .glx-smart-select__chevron{transform:rotate(225deg) translate(-1px,-1px)}
${SCOPE} .glx-smart-select__menu{position:fixed;inset:auto;box-sizing:border-box;padding:6px;max-height:min(320px,42vh);overflow-y:auto;overflow-x:hidden;overscroll-behavior:contain;border:1px solid rgba(180,151,255,.34);border-radius:14px;background:radial-gradient(circle at 18% 0%,rgba(126,87,255,.18),transparent 42%),linear-gradient(145deg,rgba(19,17,34,.98),rgba(7,7,14,.99));box-shadow:0 22px 58px rgba(0,0,0,.55),0 0 34px rgba(112,78,255,.10),inset 0 1px 0 rgba(255,255,255,.045);-webkit-backdrop-filter:blur(22px) saturate(130%);backdrop-filter:blur(22px) saturate(130%);z-index:2147483600}
${SCOPE} .glx-smart-select__menu[hidden]{display:none!important}
${SCOPE} .glx-smart-select__option{display:block;width:100%;min-height:40px;padding:9px 10px;border:0;border-radius:10px;background:transparent;color:#fff;font:inherit;font-size:.94em;line-height:1.35;text-align:left;white-space:normal;overflow-wrap:anywhere;cursor:pointer}
${SCOPE} .glx-smart-select__option:hover,${SCOPE} .glx-smart-select__option:focus-visible,${SCOPE} .glx-smart-select__option[aria-selected="true"]{outline:none;background:linear-gradient(135deg,rgba(126,87,255,.24),rgba(72,143,255,.11));color:#fff}
${SCOPE} .glx-smart-select__option[aria-selected="true"]{box-shadow:inset 0 0 0 1px rgba(180,151,255,.22)}
${SCOPE} .glx-smart-select__option:disabled{opacity:.45;cursor:not-allowed}
`;

  const close = (ui, focusTrigger = false) => {
    if (!(ui instanceof Element)) return;
    const trigger = ui.querySelector('.glx-smart-select__trigger');
    const menu = ui.querySelector('.glx-smart-select__menu');
    ui.classList.remove('is-open');
    trigger?.setAttribute('aria-expanded', 'false');
    if (menu) menu.hidden = true;
    if (focusTrigger) trigger?.focus?.();
  };

  const closeOthers = (except = null) => {
    document.querySelectorAll(OPEN_SELECTOR).forEach((ui) => {
      if (ui !== except) close(ui);
    });
  };

  const restoreNative = (select) => {
    if (!(select instanceof HTMLSelectElement)) return;
    const ui = select.__glxSmartSelectVisual;
    if (ui) {
      close(ui);
      ui.remove();
    }
    select.classList.remove('glx-native-select--visual');
    const original = select.__glxSmartSelectOriginal;
    if (original) {
      if (original.tabindex === null) select.removeAttribute('tabindex');
      else select.setAttribute('tabindex', original.tabindex);
      if (original.ariaHidden === null) select.removeAttribute('aria-hidden');
      else select.setAttribute('aria-hidden', original.ariaHidden);
    } else {
      select.removeAttribute('aria-hidden');
      if (select.tabIndex === -1) select.removeAttribute('tabindex');
    }
    delete select.__glxSmartSelectVisual;
    delete select.__glxSmartSelectOriginal;
  };

  const position = (ui) => {
    if (!(ui instanceof Element) || !ui.classList.contains('is-open') || isTouchNativeMode()) return;
    const trigger = ui.querySelector('.glx-smart-select__trigger');
    const menu = ui.querySelector('.glx-smart-select__menu');
    if (!trigger || !menu || menu.hidden) return;

    const rect = trigger.getBoundingClientRect();
    const viewportPad = 10;
    const gap = 6;
    const width = Math.max(180, Math.min(rect.width, window.innerWidth - viewportPad * 2));
    menu.style.width = `${Math.round(width)}px`;
    menu.style.left = `${Math.round(Math.max(viewportPad, Math.min(rect.left, window.innerWidth - width - viewportPad)))}px`;

    const maxHeight = Math.max(140, Math.min(320, window.innerHeight * .42));
    menu.style.maxHeight = `${Math.round(maxHeight)}px`;
    const measuredHeight = Math.min(menu.scrollHeight || maxHeight, maxHeight);
    const below = window.innerHeight - rect.bottom - viewportPad;
    const above = rect.top - viewportPad;
    const openUp = below < Math.min(measuredHeight, 210) && above > below;
    const available = Math.max(110, (openUp ? above : below) - gap);
    const finalHeight = Math.min(measuredHeight, available);
    menu.style.maxHeight = `${Math.round(finalHeight)}px`;

    let top = openUp ? rect.top - finalHeight - gap : rect.bottom + gap;
    top = Math.max(viewportPad, Math.min(top, window.innerHeight - finalHeight - viewportPad));
    menu.style.top = `${Math.round(top)}px`;
  };

  const schedulePosition = () => {
    if (raf) return;
    raf = window.requestAnimationFrame(() => {
      raf = 0;
      document.querySelectorAll(OPEN_SELECTOR).forEach(position);
    });
  };

  const sync = (select) => {
    if (!(select instanceof HTMLSelectElement)) return;
    if (isTouchNativeMode()) {
      restoreNative(select);
      return;
    }
    const ui = select.__glxSmartSelectVisual;
    if (!ui) return;
    const trigger = ui.querySelector('.glx-smart-select__trigger');
    const value = ui.querySelector('.glx-smart-select__value');
    const menu = ui.querySelector('.glx-smart-select__menu');
    if (!trigger || !value || !menu) return;

    const options = Array.from(select.options || []);
    const selected = select.selectedOptions?.[0] || options[select.selectedIndex] || options[0];
    value.textContent = selected?.textContent?.trim() || 'Select';
    value.title = selected?.textContent?.trim() || '';
    trigger.disabled = Boolean(select.disabled || !options.length);
    trigger.setAttribute('aria-disabled', trigger.disabled ? 'true' : 'false');
    if (trigger.disabled) close(ui);

    const fragment = document.createDocumentFragment();
    options.forEach((option, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'glx-smart-select__option';
      button.dataset.value = option.value;
      button.dataset.index = String(index);
      button.textContent = option.textContent?.trim() || option.label || 'Option';
      button.setAttribute('role', 'option');
      button.setAttribute('aria-selected', option.selected ? 'true' : 'false');
      button.disabled = Boolean(option.disabled);
      fragment.appendChild(button);
    });
    menu.replaceChildren(fragment);
    if (ui.classList.contains('is-open')) schedulePosition();
  };

  const open = (ui, keyboardDirection = 0) => {
    if (isTouchNativeMode()) return;
    const select = ui?.__glxSourceSelect;
    const trigger = ui?.querySelector?.('.glx-smart-select__trigger');
    const menu = ui?.querySelector?.('.glx-smart-select__menu');
    if (!select || !trigger || !menu || trigger.disabled) return;
    closeOthers(ui);
    sync(select);
    ui.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    menu.hidden = false;
    window.requestAnimationFrame(() => {
      position(ui);
      if (!keyboardDirection) return;
      const buttons = Array.from(menu.querySelectorAll('.glx-smart-select__option:not(:disabled)'));
      if (!buttons.length) return;
      const selectedIndex = buttons.findIndex((button) => button.getAttribute('aria-selected') === 'true');
      const index = selectedIndex >= 0 ? selectedIndex : (keyboardDirection > 0 ? 0 : buttons.length - 1);
      buttons[index]?.focus();
    });
  };

  const enhance = (select) => {
    if (!(select instanceof HTMLSelectElement) || !select.closest(SCOPE)) return;
    if (isTouchNativeMode()) {
      restoreNative(select);
      return;
    }
    if (select.__glxSmartSelectVisual) {
      sync(select);
      return;
    }

    const field = select.closest('.glx-field');
    if (!field) return;
    const fieldLabel = field.querySelector(':scope > span')?.textContent?.trim() || 'Selection';

    select.__glxSmartSelectOriginal = {
      tabindex: select.getAttribute('tabindex'),
      ariaHidden: select.getAttribute('aria-hidden')
    };

    uid += 1;
    const ui = document.createElement('div');
    ui.className = 'glx-smart-select';
    const menuId = `glx-byl-smart-menu-${uid}`;
    ui.innerHTML = `<button type="button" class="glx-smart-select__trigger" aria-haspopup="listbox" aria-expanded="false" aria-controls="${menuId}" aria-label="${fieldLabel.replace(/"/g, '&quot;')}"><span class="glx-smart-select__value"></span><span class="glx-smart-select__chevron" aria-hidden="true"></span></button><div id="${menuId}" class="glx-smart-select__menu" role="listbox" hidden></div>`;
    select.insertAdjacentElement('afterend', ui);
    select.classList.add('glx-native-select--visual');
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');
    select.__glxSmartSelectVisual = ui;
    ui.__glxSourceSelect = select;

    const trigger = ui.querySelector('.glx-smart-select__trigger');
    const menu = ui.querySelector('.glx-smart-select__menu');

    select.addEventListener('change', () => sync(select));
    trigger.addEventListener('click', () => {
      if (ui.classList.contains('is-open')) close(ui);
      else open(ui);
    });
    trigger.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        event.stopPropagation();
        open(ui, event.key === 'ArrowDown' ? 1 : -1);
      } else if (event.key === 'Escape' && ui.classList.contains('is-open')) {
        event.preventDefault();
        event.stopPropagation();
        close(ui, true);
      }
    });

    menu.addEventListener('click', (event) => {
      const optionButton = event.target instanceof Element ? event.target.closest('.glx-smart-select__option') : null;
      if (!(optionButton instanceof HTMLButtonElement) || optionButton.disabled) return;
      const nextValue = optionButton.dataset.value ?? '';
      if (select.value !== nextValue) {
        select.value = nextValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      sync(select);
      close(ui, true);
    });

    menu.addEventListener('keydown', (event) => {
      const current = event.target instanceof Element ? event.target.closest('.glx-smart-select__option') : null;
      if (!(current instanceof HTMLButtonElement)) return;
      const buttons = Array.from(menu.querySelectorAll('.glx-smart-select__option:not(:disabled)'));
      const index = buttons.indexOf(current);
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        event.stopPropagation();
        const step = event.key === 'ArrowDown' ? 1 : -1;
        buttons[(index + step + buttons.length) % buttons.length]?.focus();
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        event.stopPropagation();
        buttons[event.key === 'Home' ? 0 : buttons.length - 1]?.focus();
      } else if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        close(ui, true);
      }
    });

    sync(select);
  };

  const refreshWithin = (root = document) => {
    if (root instanceof HTMLSelectElement && root.matches(SELECTOR)) enhance(root);
    root?.querySelectorAll?.(SELECTOR).forEach(enhance);
    if (root instanceof HTMLOptionElement) {
      const select = root.parentElement;
      if (select instanceof HTMLSelectElement && select.matches(SELECTOR)) enhance(select);
    }
  };

  const refresh = () => {
    if (isTouchNativeMode()) closeOthers();
    refreshWithin(document);
  };

  document.addEventListener('pointerdown', (event) => {
    if (isTouchNativeMode()) return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    document.querySelectorAll(OPEN_SELECTOR).forEach((ui) => {
      if (!ui.contains(target)) close(ui);
    });
    if (target.closest(`${SCOPE} .glx-x, ${SCOPE} .glx-bd`)) closeOthers();
  }, true);

  window.addEventListener('resize', () => {
    refresh();
    schedulePosition();
  }, { passive: true });
  window.addEventListener('orientationchange', refresh, { passive: true });
  document.addEventListener('scroll', schedulePosition, { passive: true, capture: true });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.target instanceof HTMLSelectElement && mutation.target.matches(SELECTOR)) enhance(mutation.target);
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) refreshWithin(node);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });

  window.__glxBundleSelectVisualV1 = {
    version: 'v1.1-touch-native',
    refresh,
    sync,
    closeAll: closeOthers,
    isNativeMode: isTouchNativeMode
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();
